import React from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import Dashboard from './components/Dashboard';
import Footer from './components/Footer';
import VisualElements from './components/VisualElements';

const App: React.FC = () => {
  return (
    <div className="App">
      <VisualElements />
      <div className="container">
        <Header />
        <HeroSection />
        <Dashboard />
        <Footer />
      </div>
    </div>
  );
};

export default App;
